import { haveActiveChild } from './content'
import { getNextNestedItemState } from './list'
import { TableOfContentsItem } from '~/portal/types/content'
import { TemplateContent } from '~/portal/types/template'

export const getUrlAfterRemoveProductNestedContent = (pathname: string, productSlug: string, items: Array<TableOfContentsItem>, currentItemId: string | undefined): string => {
  if (pathname !== `/sp-admin/products/${productSlug}/edit/content/${currentItemId}`) {
    const activeItemId = pathname.split(`/sp-admin/products/${productSlug}/edit/content/`).pop()

    return haveActiveChild<TableOfContentsItem>(items, currentItemId, activeItemId) ? `/sp-admin/products/${productSlug}/edit/new` : ''
  }
  const nextItem = getNextNestedItemState(items, currentItemId)

  return nextItem ? `/sp-admin/products/${productSlug}/edit/content/${nextItem.id}` : `/sp-admin/products/${productSlug}/edit/new`
}

export const getUrlAfterRemoveTemplateNestedContent = (pathname: string, templateId: string, items: Array<TemplateContent>, currentItemId: string | undefined): string => {
  if (pathname !== `/sp-admin/templates/${templateId}/edit/content/${currentItemId}`) {
    const activeItemId = pathname.split(`/sp-admin/templates/${templateId}/edit/content/`).pop()

    return haveActiveChild<TemplateContent>(items, currentItemId, activeItemId) ? `/sp-admin/templates/${templateId}/edit/new` : ''
  }
  const nextItem = getNextNestedItemState(items, currentItemId)

  return nextItem ? `/sp-admin/templates/${templateId}/edit/content/${nextItem.id}` : `/sp-admin/templates/${templateId}/edit/new`
}

export const getPageAppTitle = (platformManaged: boolean = false) => platformManaged ? 'Portal' : 'SwaggerHub Portal'